import { Form, FormFactory } from '@ubud/form';
import { FormBuilder } from '@angular/forms';
import { Injectable } from '@angular/core';
import { RegisterUserRule } from '@lemsar/auth/rules/register-user.rule';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    12/06/2018
 */
@Injectable()
export class RegisterUserFormFactory implements FormFactory {
    public constructor(private fb: FormBuilder) {}

    public create(): Form {
        const formRule = new RegisterUserRule();

        return {
            formGroup: this.fb.group(formRule.getFormControls()),
            rules: [formRule],
        };
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/factories/register-user-form.factory.ts